import { render, staticRenderFns } from "./DeviceNotifyList.vue?vue&type=template&id=f0fb8022&scoped=true&"
import script from "./DeviceNotifyList.vue?vue&type=script&lang=js&"
export * from "./DeviceNotifyList.vue?vue&type=script&lang=js&"
import style0 from "./DeviceNotifyList.vue?vue&type=style&index=0&id=f0fb8022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fb8022",
  null
  
)

export default component.exports